// extracted by mini-css-extract-plugin
module.exports = {"Container":"Tables_Container__2A06z","Loading":"Tables_Loading__PqW3y","NotFound":"Tables_NotFound__1BPd1"};